<template>
  <div class="member-box content-1200">
    <div class="text-center font-blod color-level1 margin-b60 fontSize36">联盟成员</div>
    <template v-for="item in list">
      <div v-if="item.members.length" :key="item.category">
        <div class="color-level1 fontWeight-500 fontSize24 margin-b20">{{ item.title }}</div>
        <div class="member">
          <img v-for="member in item.members" :src="member.img" alt="" :key="member.id">
        </div>
      </div>
    </template>
  </div>
</template>
<script>

export default {
  props: {
    partnersList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: [
        {category: 1, title: '常务理事长单位', members: []},
        {category: 2, title: '理事长单位', members: []},
        {category: 3, title: '理事单位', members: []},
        {category: 4, title: '荣誉理事单位', members: []},
        {category: 5, title: '生态单位', members: []},
        {category: 6, title: '合作伙伴', members: []},
      ]
    }
  },
  watch: {
    partnersList(newValue) {
      if (newValue && newValue.length) {
        newValue.forEach(item => {
          switch (item.category) {
            case 1:
              this.list[0].members.push(item);
              break;
            case 2:
              this.list[1].members.push(item);
              break;
            case 3:
              this.list[2].members.push(item);
              break;
            case 4:
              this.list[3].members.push(item);
              break;
            case 5:
              this.list[4].members.push(item);
              break;
            case 6:
              this.list[5].members.push(item);
              break;
          }
        })
        console.log(this.list);
      }
    }
  }
}
</script>
<style scoped lang="scss">
.member-box {
  padding: 80px 0 40px;
  height: auto;

  .member {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    margin-bottom: 40px;

    &:last-of-type {
      margin-bottom: 20px;
    }

    img {
      width: 183px;
      height: 64px;
      margin-bottom: 20px;
    }
  }
}

</style>
